module.exports = __webpack_public_path__ + "img/Differentiation-PDAC_GSE205354.c3eb44a7.png";